<div *ngIf="popupName == 'NoOfSurveysCreated'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_regular">Number of Survery Created</p>
          </div>
          <div class="popup-close">
            <div class="mr-30">
              <label class="fs-16 fs_14ForMobile font_regular mr-15">Incomplete</label>
              <mat-slide-toggle class="toggle-element mr-10" [(ngModel)]="isToggleChecked"
              (change)="onChangeSwitch($event)"></mat-slide-toggle>
              <label class="fs-16 fs_14ForMobile font_regular ml-15">Complete</label>
            </div>
            <button class="download-btn">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
            </button>
            <span [mat-dialog-close] class="ml-35 ml-sm-15 mr-5 fs-30 fs_24ForMobile material-icons popup-close-icon">close</span>
          </div>
        </div>
        
      </ion-col>
    </ion-row>
    
    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table class="Market-correction-employees-table" id="incompleteTable">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Start Date
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    End Date
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Name of survey
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Question
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Response type
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Av. rating
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Completion status
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container  *ngFor="let item of scoresOfSurveysList">
                <tr *ngFor="let data of item.questions">
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">
                  {{item.startDate | date:'dd-MM-yyyy'}}</td>
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">
                  {{item.endDate | date:'dd-MM-yyyy'}}</td>
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">{{item.essName}}</td>
                  <td>{{data.question}}</td>
                  <td>{{data.questiontype}}</td>
                  <td>{{data.score}}</td>
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">
                  <div class="icon-container">
                    <span>{{item.completed}}/{{item.total}}</span>
                    <div class="tooltip">
                      <div class="info-popup">
                        <span *ngFor="let incompleteEmp of item?.incompleteEmps;let isLast = last">{{incompleteEmp.firstName}} {{incompleteEmp.lastName}}{{isLast ? '' : ', '}}</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</div>
</div>

<div *ngIf="popupName == 'scoresOfSurveys'">
  <div class="cardLayout">
    <ion-row class="col-md-reverse">
      <ion-col size="12" size-md class="phi-align-content-center">
        <div class="popup-heading">
          <p class="fs-16 fs_14ForMobile font_regular">Score Of  Surveys</p>
          <div class="mb-md-15">
            <label class="fs-16 fs_14ForMobile font_regular mr-15">Incomplete</label>
            <mat-slide-toggle class="toggle-element mr-10" [(ngModel)]="isToggleChecked" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label class="fs-16 fs_14ForMobile font_regular ml-15">Complete</label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12" size-md="auto" class="phi-align-content-center">
        <div class="popup-close mb-md-15">
          <button (click)="onClickDownloadScoresOfSurveys('ScoresOfSurveys')" class="download-btn">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
          </button>
          <span [mat-dialog-close] class="ml-35 ml-md-10 mr-5 fs-30 fs_24ForMobile material-icons popup-close-icon">close</span>
        </div>
      </ion-col>
    </ion-row>
    
    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table class="Market-correction-employees-table" id="ScoresOfSurveys">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Start Date
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    End Date
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Name of survey
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Question
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Response type
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Av. rating
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Completion status
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container  *ngFor="let item of scoresOfSurveysList">
                <tr *ngFor="let data of item.questions">
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">
                  {{item.startDate | date:'dd-MM-yyyy'}}</td>
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">
                  {{item.endDate | date:'dd-MM-yyyy'}}</td>
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">{{item.essName}}</td>
                  <td>{{data.question}}</td>
                  <td>{{data.questiontype}}</td>
                  <td>{{data.score}}</td>
                  <td *ngIf="data === item.questions[0]"
                  [attr.rowspan]="item.questions.length">
                  <div class="icon-container">
                    <span>{{item.completed}}/{{item.total}}</span>
                    <div class="tooltip" *ngIf="isDownload">
                      <div class="info-popup">
                        <span *ngFor="let incompleteEmp of item?.incompleteEmps;let isLast = last">{{incompleteEmp.firstName}} {{incompleteEmp.lastName}}{{isLast ? '' : ', '}}</span>
                      </div>
                    </div>
                  </div></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="popupName == 'noOfEmployee'">
  <div class="cardLayout">
    <ion-row class="col-md-reverse">
      <ion-col size="12" size-md class="phi-align-content-center">
        <div class="popup-heading">
          <p class="fs-16 fs_14ForMobile font_regular">Number of Employee ({{listOfEmployees.length}})</p>
          <div class="mb-md-15">
            <label class="fs-16 fs_14ForMobile font_regular mr-15">Incomplete</label>
            <mat-slide-toggle class="toggle-element mr-10" [(ngModel)]="isToggleChecked" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label class="fs-16 fs_14ForMobile font_regular ml-15">Complete</label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12" size-md="auto" class="phi-align-content-center">
        <div class="popup-close mb-md-15">
          <button (click)="onClickDownloadnoOfEmployee()" class="download-btn">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
          </button>
          <span [mat-dialog-close] class="ml-35 ml-md-10 mr-5 fs-30 fs_24ForMobile material-icons popup-close-icon">close</span>
        </div>
      </ion-col>
    </ion-row>
    
    <ion-row>
      <ion-col size="12">
        <div class="table-container">
          <table class="Market-correction-employees-table" id="incompleteTable">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Employee ID
                  </div>
                </th>
                <th class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="icon-style">
                    Employee Name
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listOfEmployees">
                <td>{{item.employeeId}}</td>
                <td>{{item.firstName}} {{item.lastName}}</td>  
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>